import { useState } from "react";
import useQueryConfig from "./useQueryConfig";
import { dataStateType } from "../constants/status";

const useControlPanel = () => {
  const queryConfig = useQueryConfig();
  let { page } = queryConfig;
  const [searchKey, setSearchKey] = useState("");
  const [numberPage, setNumberPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [status, setStatus] = useState(dataStateType.ACTIVE);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const startIndex = (numberPage - 1) * limit;
  const endIndex = numberPage * limit;

  const handleInputChange = (e, search) => {
    const { value } = e.target;
    setNumberPage(1);
    setSearchKey(value);
    if (search) {
      search(value);
    }
  };

  const handleChangePage = (page) => {
    setNumberPage(page);
  };

  const handleChangeStatus = (status) => {
    setStatus(status);
  };

  //   const handleChangeLimit = (limit) => {
  //     setLimit(limit);
  //   };

  //   const handleChangeStartDate = (startDate) => {
  //     setLimit(startDate);
  //   };

  //   const handleChangeEndDate = (endDate) => {
  //     setLimit(endDate);
  //   };

  return {
    page,
    searchKey,
    limit,
    setLimit,
    numberPage,
    setNumberPage,
    status,
    setStatus,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    startIndex,
    endIndex,
    handleInputChange,
    handleChangePage,
    handleChangeStatus,
  };
};

export default useControlPanel;
